import { ReactNode } from 'react';
import heroImg from '@/assets/hero-mountains.webp';
import SolaLogo from '@/components/SolaLogo';

const AuthLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      {/* Image side */}
      <div className="hidden md:block md:w-1/2 relative overflow-hidden">
        <img
          src={heroImg}
          alt=""
          // @ts-expect-error fetchpriority is a valid HTML attribute
          fetchpriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground/50 to-foreground/10" />
        <div className="absolute top-8 left-8">
          <SolaLogo size="md" variant="light" showWordmark />
        </div>
        <div className="absolute bottom-12 left-12 right-12">
          <h2 className="font-serif text-4xl text-primary-foreground leading-tight mb-3">
            Descubra a beleza<br />da Palavra
          </h2>
          <p className="text-primary-foreground/70 text-sm leading-relaxed">
            Pregações transformadas em reflexões profundas para sua jornada espiritual.
          </p>
        </div>
      </div>

      {/* Form side */}
      <main className="flex-1 flex items-center justify-center p-6 md:p-12 bg-cream min-h-screen md:min-h-0">
        <div className="w-full max-w-sm animate-fade-in">
          <div className="md:hidden mb-10 flex justify-center">
            <SolaLogo size="lg" showWordmark />
          </div>
          {children}
        </div>
      </main>
    </div>
  );
};

export default AuthLayout;
